<div class="connection-lost-overlay">
  <div
    class="connection-lost-overlay__content"
    [ngClass]="{ 'accent-border': accentIsShown }"
  >
    <i class="icon-attention"></i>
    <div class="connection-lost-overlay__content-text">{{ context.text }}</div>
  </div>
</div>
